import React from 'react';
import { Bar } from 'react-chartjs-2';

// Import required parts of Chart.js to register the bar chart functionality
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register chart components to make them usable globally
ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

const ProfitLossChart = (chrtData) => {
  let obj = {
    ...chrtData
  }

  // console.log("obj: ", obj);



  // Fallback/default if props are missing
  const safeData = obj.chrtData.length === 4 ? obj.chrtData : [0, 0, 0, 0];
  // console.log("Safedata: ", safeData);


  const chartData = {
    labels: ['Estimated Profit', 'Incentive', 'Expenses', safeData[3] > 0 ? 'Final Profit' : 'Loss'], // x-axis labels
    datasets: [
      {
        label: '₹ Amount', // label in tooltip/legend
        data: safeData,
        backgroundColor: ['#4ade80', '#3b82f6', '#f87171', safeData[3] > 0 ? '#10b981' : "#ff0000"], // bar colors
        borderRadius: 5, // border radius
        barThickness: 120, // bar thickness
      },
    ],
  };

  // Chart configuration options
  const options = {
    responsive: true, // makes the chart responsive
    plugins: {
      title: {
        display: true,
        text: 'Profit and Loss Overview', // chart title
        font: { size: 40 },
      },
      legend: {
        display: false, // hides the legend since there's only one dataset
      },
    },
    scales: {
      y: {
        beginAtZero: true, // start y-axis from 0
        ticks: {
          stepSize: 25000, // increment steps on y-axis
        },
      },
    },
  };



  return <>
    <div className='flex justify-center items-center'>
      <Bar className='font-bold max-w-[90rem] max-h-[40rem]' data={chartData} options={options} />
    </div>
  </>
};

export default ProfitLossChart;
